<template>
  <a-config-provider :locale="locale">
    <Loading ref="loading" />
    <router-view />
  </a-config-provider>
</template>

<script>
// eslint-disable-next-line camelcase
import ja_JP from 'ant-design-vue/es/locale/ja_JP';
import Loading from '@/components/Loading/Loading.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    Loading,
  },
  data() {
    return {
      locale: ja_JP,
    };
  },
  computed: {
    ...mapGetters('modal', ['isContinueAction']),
  },
  created() {
    window.addEventListener('beforeunload', (e) => {
      if (!this.isContinueAction) {
        e.preventDefault();
        e.returnValue = '';
      }
    });
  },
  mounted() {
    console.info('App version 4.2');
    // disable inspect by right mouse
    // document.addEventListener('contextmenu', (e) => {
    //   e.preventDefault();
    // });
  },
  watch: {
    $route(newVal) {
      if (newVal.name === 'Estate Detail' || newVal.name === 'EstateDetailSeller') {
        document.getElementsByTagName('BODY')[0].classList.add('padding-footer');
      } else {
        document.getElementsByTagName('BODY')[0].classList.remove('padding-footer');
      }
    }
  },
};
</script>

<style lang="scss"></style>
